<template>
    <div class="container page-router-component">
        <router-view style="width: 100%;"></router-view>
    </div>
</template>

<script>

export default {
    name: "PageRouter",
}
</script>

<style scoped>
.container {
    box-sizing: border-box;
    width: 100%;
    max-width: none;
    margin-top: 8px;
    padding-right: 0;
    padding-left: 0;
    display:flex;
    min-width: 0;
}

.container > * {
    width: 100%;
    min-width: 0;
}
</style>
